import { AbstractDictionary } from "./AbstractDictionary";
export class DicIdpActionType extends AbstractDictionary {
  static NAME = "tsadv_DicIdpActionType";
}
export type DicIdpActionTypeViewName =
  | "_base"
  | "_local"
  | "_minimal"
  | "dicIdpActionType.edit";
export type DicIdpActionTypeView<
  V extends DicIdpActionTypeViewName
> = V extends "_base"
  ? Pick<
      DicIdpActionType,
      | "id"
      | "langValue"
      | "code"
      | "endDate"
      | "langValue1"
      | "langValue2"
      | "langValue3"
      | "langValue4"
      | "langValue5"
      | "startDate"
      | "legacyId"
      | "organizationBin"
      | "integrationUserLogin"
      | "description1"
      | "description2"
      | "description3"
      | "description4"
      | "description5"
      | "isSystemRecord"
      | "active"
      | "isDefault"
      | "order"
    >
  : V extends "_local"
  ? Pick<
      DicIdpActionType,
      | "id"
      | "legacyId"
      | "organizationBin"
      | "integrationUserLogin"
      | "langValue1"
      | "description1"
      | "langValue2"
      | "description2"
      | "langValue3"
      | "description3"
      | "langValue4"
      | "description4"
      | "langValue5"
      | "description5"
      | "startDate"
      | "endDate"
      | "code"
      | "isSystemRecord"
      | "active"
      | "isDefault"
      | "order"
    >
  : V extends "_minimal"
  ? Pick<
      DicIdpActionType,
      | "id"
      | "langValue"
      | "code"
      | "endDate"
      | "langValue1"
      | "langValue2"
      | "langValue3"
      | "langValue4"
      | "langValue5"
      | "startDate"
    >
  : V extends "dicIdpActionType.edit"
  ? Pick<
      DicIdpActionType,
      | "id"
      | "legacyId"
      | "organizationBin"
      | "integrationUserLogin"
      | "langValue1"
      | "description1"
      | "langValue2"
      | "description2"
      | "langValue3"
      | "description3"
      | "langValue4"
      | "description4"
      | "langValue5"
      | "description5"
      | "startDate"
      | "endDate"
      | "code"
      | "isSystemRecord"
      | "active"
      | "isDefault"
      | "order"
      | "company"
    >
  : never;
